import { ComponentType } from './../../SavedSearch/SavedSearch';
import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"

interface quickInputState {
    showQuickInput: boolean,
    expand: boolean,
    componentType: ComponentType | null
}

const initialState: quickInputState = {
    showQuickInput: false,
    expand: true,
    componentType: null
}

export const QuickInputSlice = createSlice({
    name: "QuickInput",
    initialState,
    reducers: {
        showQuickInput: (state, action: PayloadAction<boolean>) => {
            state.showQuickInput = action.payload;
        },
        setComponentType: (state, action: PayloadAction<ComponentType>) => {
            state.componentType = action.payload;
        },
        setExpand: (state, action: PayloadAction<boolean>) => {
            state.expand = action.payload;
        },
    }
});

export const quickInputSelector = createSelector(
    (state: RootState) => state.quickInput,
    (data) => data
);

export const {
    showQuickInput,
    setComponentType,
    setExpand
} = QuickInputSlice.actions;

export default QuickInputSlice.reducer;